/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: watermark-asset-service.ts
 *
 * Created by kyang on 10/28/20.
 */

// This service is an implementation for BrandingAssetService.
// Components should invoke the abstract BrandingAssetService, not this specific implementation.

angular.module('prism-ui.components.branding').service('WatermarkAssetService', function (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    BrandingAssetService: JS5Object,
    WatermarkResourceFactory: JS5Object,
) {

    //==========================//
    // Branding Asset Container //
    //==========================//

    this.getBrandingAssetContainer = (containerId: string) => {
        return WatermarkResourceFactory.get({containerId}).$promise;
    };

    this.parseBrandingAssetContainer = (brandingConfig: JS5Object, brandingAssetContainer: JS5Object) => {
        brandingAssetContainer.assets = BrandingAssetService.filterBrandingAssets(brandingConfig, brandingAssetContainer.assets, {anySeasonVolume: true});
    };

    this.updateBrandingAssetContainer = (brandingConfig: JS5Object, brandingAssetContainer: JS5Object) => {
        return WatermarkResourceFactory.update({
            containerId: brandingAssetContainer.id
        }, brandingAssetContainer).$promise;
    };


    //=======//
    // Asset //
    //=======//

    const createEmptyRootBrandingAsset = (brandingConfig: JS5Object, acceptProfile: JS5Object) => {
        let rootAsset: JS5Object = {videoAcceptProfile: acceptProfile};
        if (brandingConfig.seasonId) {
            rootAsset.seasonId = brandingConfig.seasonId;
        } else if (brandingConfig.volumeId) {
            rootAsset.volumeId = brandingConfig.volumeId;
        }
        return rootAsset;
    };

    this.getRootBrandingAsset = (brandingConfig: JS5Object, container: JS5Object, acceptProfile: JS5Object) => {
        let watermarkAssets = BrandingAssetService.filterBrandingAssets(brandingConfig, container.assets);
        let rootAsset = _.find(watermarkAssets, {
            videoAcceptProfile: {id: acceptProfile.id}
        });
        return (!!rootAsset) ? rootAsset : createEmptyRootBrandingAsset(brandingConfig, acceptProfile);
    };

    this.validateNonTextAsset = (acceptProfileId: number, asset: JS5Object, virtualPath: string) => {
        // Watermarks aren't validated
        return $q.when([]);
    };

    this.createRootBrandingAsset = (brandingConfig: JS5Object, rootAsset: JS5Object) => {
        return WatermarkResourceFactory.createAsset({containerId: brandingConfig.id}, rootAsset).$promise;
    };

    this.updateRootBrandingAsset = (brandingConfig: JS5Object, rootAsset: JS5Object) => {
        return WatermarkResourceFactory.updateAsset({assetId: rootAsset.id}, rootAsset).$promise;
    };


    //=========//
    // Proxies //
    //=========//

    this.hasVideoAssetProxyStatus = (brandingConfig: JS5Object, rootAsset: JS5Object) => {
        return false;
    };
});


//=================//
// Lifecycle Hooks //
//=================//

// Load this service when app is initialized
angular.module('prism-ui.components.branding').run((
    BrandingAssetService: JS5Object,
    WatermarkAssetService: JS5Object,
) => {
    BrandingAssetService.registerAssetServiceImplementation('watermarks', WatermarkAssetService);
});
